import React from 'react';
import ReactDOM from 'react-dom';
import { Button, Container } from '@pw-tech/omni-ui';
const FooterPortal = ({
  label,
  type,
  disabled = false,
  isFormSubmitting = false,
  btnWrapperClass,
  onClick,
  formId
}: {
  label: string;
  type: 'submit' | 'button';
  disabled?: boolean;
  isFormSubmitting?: boolean;
  btnWrapperClass?: string;
  onClick?: () => void;
  formId?: string;
}) => {
  return ReactDOM.createPortal(<div className="fixed bottom-0 w-full py-2 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
      <Container className="mx-auto px-4 md:!px-0">
        <div className={btnWrapperClass}>
          <Button size="medium" variant="primary" className="w-full rounded-lg sm:!w-auto" type={type} disabled={disabled || isFormSubmitting} onClick={onClick} form={formId} postIcon={isFormSubmitting ? <div className="w-4 h-4 m-[2px] border-2 border-white rounded-full border-t-transparent animate-spin" /> : null}>
            {label}
          </Button>
        </div>
      </Container>
    </div>, document?.getElementById('portal-root') as HTMLElement);
};
export default FooterPortal;